export default function cardsSprite(jpg, w, h, l, callBack) {
	const img = new Image();

	function drawCard(x, y, d) {
		let c = document.createElement('canvas'),
			wi = img.width / w,
			he = img.height / h,
			cx = c.getContext('2d');
		c.height = he * 2;
		c.width = wi;
		c.classList.add('card-picture');
		function di() {
			cx.drawImage(img, x * wi, y * he, wi, he, 0, 0, c.width, he);
		}
		di();
		cx.translate(c.width, c.height);
		cx.rotate((180 * Math.PI) / 180);
		di();
		cx.moveTo(0, c.height / 2);
		cx.lineTo(c.width, c.height / 2);
		cx.lineWidth = l;
		cx.strokeStyle = 'rgba(0,0,0,0.5)';
		cx.stroke();

		if (d) {
			let dx = cx.getImageData(0, 0, c.width, c.height),
				px = dx.data;
			for (let i = 0, n = px.length; i < n; i += 4) {
				let g = px[i] * 0.4 + px[i + 1] * 0.4 + px[i + 2] * 0.3;
				px[i] = g;
				px[i + 1] = g;
				px[i + 2] = g;
			}
			cx.putImageData(dx, 0, 0);
		}
		return c;
	}

	img.addEventListener('load', function () {
		setTimeout(function () {
			callBack(drawCard);
		}, 300);
	});

	img.crossOrigin = 'anonymous';
	img.src = jpg;
}
